export default {
  REMINDERS_FETCHED(state, reminders) {
    state.reminders = reminders
  }
}
